import React from 'react'
import PropTypes from 'prop-types'

const Spacer = ({ className }) => <div className={className} />

Spacer.propTypes = {
  className: PropTypes.string,
}

Spacer.defaultProps = {
  className: 'h-48 1000:h-64',
}

export default Spacer
